<template>
  <div class="form-elements va-row">

      <div class="flex sm4 xs12 offset--sm4">
        <va-card :title="$t('Create Watched account')">

          <loading :active.sync="loading" :is-full-page="false"></loading>

          <form @submit.prevent="onsubmit()" class="text-right">
                
                <va-input
                  name="Account Id"
                  v-model="payload.account_id"
                  placeholder="Account Id"
                  :errorMessages="[account_id_err]"
                  :error="account_id_has_err"
                />

                <va-input
                  name="Display Name"
                  v-model="payload.display_name"
                  placeholder="Display Name"
                  :errorMessages="[display_name_err]"
                  :error="display_name_has_err"
                />

                <va-input
                  name = "Screen Name"
                  v-model="payload.screen_name"
                  placeholder="Screen Name"
                  :errorMessages="[screen_name_err]"
                  :error="screen_name_has_err"
                />
                
                <va-button color="success" :to="{ name: 'WatchedAccountList' }" >Back</va-button>
                <va-button color="info" type="submit">Create watched account</va-button>
              
          </form>
        </va-card>
      </div>

  </div>
</template>

<script>

import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import Validation from '@/mixins/ValidationMixin';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'account-form',
  mixins: [Validation.Validation],
  components:{Loading},
  data () {
    return {
      loading: false,
      payload: {
        account_id:"",
        display_name:"",
        screen_name:""
      }
    }
  },

  computed: {

    ...Validation.mapValidationKeys([
        "account_id",
        "screen_name",
        "display_name"
    ]),

  },

  methods: {

     ...mapActions({
      save: 'createAccount'
    }),

    onsubmit () {

      this.loading  = true;
      this.save( this.payload ).then( response => {
          this.$router.push({ name: 'WatchedAccountList' })
      }).catch( exeption => (this.valErr = exeption,this.loading = false ));


    }
  }
}
</script>

<style>
  .row.row-inside {
    max-width: none;
  }
</style>
